// Puente SSO hacia el módulo de Triage 3D (app vanilla/Three.js servida same-origin en /triage/).
//
// Como ambos viven en el mismo origen (vía nginx), comparten localStorage. El módulo triage lee
// su token desde la clave `cgt_token`. Aquí copiamos el access token de la plataforma a esa clave
// y navegamos a /triage/. El triage-api ya acepta este token (puente SSO + JIT por email),
// así que el LoginScreen propio del triage no aparece.
//
// El módulo triage debe estar buildeado con base '/triage/' y API base '/triage-api'
// (ver apps/triage/vite.config.ts e infra/compose).

import { useAuthStore, type AuthUser } from "@/lib/auth-store";

const TRIAGE_TOKEN_KEY = "cgt_token";
const TRIAGE_USER_KEY = "cgt_user";

function toTriageUser(user: AuthUser | null) {
  if (!user) return null;
  // Mapea el rol de plataforma al rol del triage (student | teacher).
  const role = user.role === "student" ? "student" : "teacher";
  return { id: user.email, email: user.email, display_name: user.full_name, role };
}

/**
 * Siembra la sesión SSO del triage (token + user) en localStorage SIN navegar.
 * Lo usa el módulo "Anatomía 3D" del hospital, que embebe el triage mismo-origen
 * en un iframe: sin esto, el triage embebido mostraría su propio login.
 */
export function seedTriageSession(): boolean {
  const { accessToken, user } = useAuthStore.getState();
  if (!accessToken) return false;
  localStorage.setItem(TRIAGE_TOKEN_KEY, accessToken);
  const tu = toTriageUser(user);
  if (tu) localStorage.setItem(TRIAGE_USER_KEY, JSON.stringify(tu));
  return true;
}

export function openTriageModule(): void {
  const { accessToken, user } = useAuthStore.getState();
  if (!accessToken) return;
  localStorage.setItem(TRIAGE_TOKEN_KEY, accessToken);
  const tu = toTriageUser(user);
  if (tu) localStorage.setItem(TRIAGE_USER_KEY, JSON.stringify(tu));
  // Navegación full-page (sale de la SPA React hacia el bundle Three.js, mismo origen).
  // Pasamos ?return= para que el triage sepa a dónde volver ("volver a la plataforma").
  window.location.assign("/triage/?return=/app");
}
